import * as Sentry from '@sentry/browser';

if (window.avant.production_env) {
  Sentry.init({
    dsn: 'https://719505006f1d45ebb1f011eabe125f93@sentry.io/151297',
    environment: process.env.TENANT,
  });
  window.Sentry = Sentry;
};
